module.exports = {"APP_ID":"scfinance","DAILY":"huikuanbao.daily.alibaba.net","PRE":"pre-huikuanbao.alibaba.com","PROD":"huikuanbao.alibaba.com","MTOP_PREFIX":"mtop.alipictures.shoukuan","CLUE_PID":"huikuanbao"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 214
// module chunks = 7